import { Controller, useFormContext } from 'react-hook-form'

import { CheckBox, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type NoKnownAccountsInvolvedProps = {
  index: number
}

export const NoKnownAccountsInvolved = ({ index }: NoKnownAccountsInvolvedProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index as 0}.noKnownAccountsInvolved`}
      control={control}
      render={({ field }) => (
        <FF2 field={field} input={(props) => <CheckBox {...props} checkBoxLabel="No known accounts involved" />} />
      )}
    />
  )
}
